import { Component, OnInit, OnDestroy, ViewChild, ElementRef, state } from '@angular/core';
import { CategoryResponse, DepartmentResult } from '../api-interfaces';
import { SkillService } from '../services/skill.service';
import 'rxjs/add/operator/takeUntil';
import { Subject, Observable, pipe } from 'rxjs';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { FlashService } from '../../flash/flash.service';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
@Component({
  selector: 'app-list-category',
  templateUrl: './list-category.component.html',
  styleUrls: ['./list-category.component.css']
})
export class ListCategoryComponent implements OnInit, OnDestroy {

  lists: Observable<CategoryResponse[]>;
  private destroy: Subject<void> = new Subject<void>();
  editData = [];
  searchResult: Observable<any>;
  searchQuery$: Observable<any>;
  categoryForm: FormGroup;
  departmentList: DepartmentResult[];
  filterCategories = {};
  searchText: FormControl;
  selectedDepartment: any;

  mySettings = {
    enableSearch: true,
    checkedStyle: 'checkboxes',
    buttonClasses: 'btn btn-default btn-block',
    maxHeight: '200px',
    displayAllSelectedText: false,
    dynamicTitleMaxItems: 100
  };

  constructor(
    public skillService: SkillService,
    public router: Router,
    private flashService: FlashService,
    private spinnerService: Ng4LoadingSpinnerService,
    private formBuilder: FormBuilder
  ) {
    this.spinnerService.show();
    this.lists = this.skillService.getCategory();

    this.skillService.getCategoryDepartment().subscribe(data => {
      this.departmentList = data;
      this.departmentList.forEach((res, index) => {
        this.departmentList[index].name = res.department_name;
        this.departmentList[index].id = res.department_id;
      });
    });

    this.spinnerService.hide();
    this.searchText = new FormControl('');
    this.searchQuery$ = this.searchText.valueChanges.startWith('');
    this.filterCategory();
  }

  ngOnInit() {
    this.categoryForm = this.formBuilder.group ({
      // department_id: new FormControl('', Validators.required),
      department_drop: new FormControl(''),
      search_text:  new FormControl('', Validators.required)
    });

  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.unsubscribe();
  }

  filterCategory(){
    this.searchResult = this.searchQuery$.combineLatest(this.lists)
    .map(([query, searchList]) => {
      return searchList.filter(state => state.category_name
      .toLowerCase().indexOf(query.toLowerCase()) !== -1)
    })
  }

  goToEdit(id, deptId) {
    this.skillService.editDataCategory = deptId;
    this.router.navigate(['/category/edit', id]);
  }

  goToFilter(categoryId ,departmentId) {
    this.router.navigate(['/skillList'], {
      queryParams: {
        categoryId: categoryId,
        departmentId: departmentId
      },
      queryParamsHandling: 'merge',
    });
  }

  deleteCategory(category_id) {
    this.spinnerService.show();
    this.skillService.deleteCategory(category_id).takeUntil(this.destroy).subscribe(
      response => {
        this.spinnerService.hide();
        if (response['status'] === true) {
          this.flashService.show(response['message'], 'alert-success');
          this.filterCategory();
          this.searchResult = this.skillService.getCategoryByDepartment(this.filterCategories)
        }
      }, error => {
        this.spinnerService.hide();
        this.flashService.show(
          error['error']['message'].replace('Skill is still active', 'The given category is mapped with employees'),
           'alert-danger');
      });
  }

  getCategoryList(departmentId, categoryName) {
    this.filterCategories = {
      "department_id": departmentId ? departmentId : [],
      "category_name": categoryName ? categoryName : ''
    }
    this.searchResult = this.skillService.getCategoryByDepartment(this.filterCategories)
  }

  trackByFn(index) {
    return index;
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/skill-matrix/list-category/list-category.component.ts